export const BLOG_POSTS = [
  {
    slug: 'redesign',
    title: 'A fresh start, and what I plan to do from here',
    date: 'January 2026',
    excerpt: 'Why I moved from cyberpunk to minimalist design.',
    content: `
Happy new year & happy holidays, it was time for a change and time to show off stuff I've made. On this website, you'll find everything I've worked on since the age of 12 onwards.

## The problem

I was quite shy of my achievements and the things I've built over the years. Roblox has always been a hobby, however now it seems like the things I've learned from these projects are perfect to showcase my skills to others.

When speaking about things I've built, I felt shy as these were kids games. But it taught me a lot about working in teams, and now instead of struggling to convey the name of the game, you can just click and play it right away.

## Recently released with a team

I recently worked my team to release a game on Roblox called Jumped based on the hit game Gang Beasts, and we've released our first dev-log below.

<iframe width="100%" height="400" src="https://www.youtube.com/embed/bmRddf6S37w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

My focus was on user building UI, deploying updates, and digging into statistical optimisation in such a way that we maximise our QPTR (qualified play through rate). 

This is done by placing funnels in key areas of gameplay to see where 'churn' occurs. Churn is simply the event of a player leaving, we want to minimise this. It's a whole game of cat and mouse to chase this down.

## What's the plan for 2026

All I know is, I wish to build something out of my comfort zone. Stepping away from Roblox game development is one of these things. It doesn't matter whether it is in software engineering, academic research, or quantitative finance. The uniqueness of my experiences should not stop me from being unique.

One of my New Year's resolutions is to blog about things I find interesting or have been working on. That way I feel responsible to visit my portfolio every now and then, but note there likely won't be any games anymore, and I will be moving onto finance things.


Best,
Aayush
    `.trim()
  }
];

export function getBlogPost(slug) {
  return BLOG_POSTS.find(post => post.slug === slug);
}
